import { ErrorState, LoadingState } from '@hemmafixa/ui';
import type { UseQueryResult } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { useI18n } from '@/i18n/context';

interface QueryViewProps<T> {
  query: UseQueryResult<T>;
  loading?: 'list' | 'cards' | 'detail';
  children: (data: T) => ReactNode;
}

/** Loading skeleton, error with retry, or the data: the same three states on every page. */
export function QueryView<T>({ query, loading = 'list', children }: QueryViewProps<T>) {
  const { t } = useI18n();
  if (query.isPending) return <LoadingState variant={loading} label={t.common.loading} />;
  if (query.isError) {
    return (
      <ErrorState
        title={t.common.errorTitle}
        message={t.common.errorMessage}
        retryLabel={t.common.retry}
        onRetry={() => void query.refetch()}
      />
    );
  }
  return <>{children(query.data)}</>;
}
